import { escape } from 'lodash-es';
import Spinner from 'spin';

import INBOX from 'INBOX';
import inx from 'inx';
import { domContentLoaded } from './utils';

import Tooltip from 'bootstrap/js/src/tooltip';

// Inbox classes
require('src/js/classes/Dialog');
// require('src/js/classes/MultipleSelectDialog');
require('src/js/classes/Contact');
require('src/js/classes/Contacts');
require('src/js/classes/RemoteClient');
require('src/js/classes/ContactsRemoteClient');
require('src/js/classes/User');

const mainJs = (() => {
    var conf = {
        aside: {
            btnGroupName: '.btn-group_aside',
            className: '.aside',
            inboxFolderID: '#m-folder_inbox',
            moreFoldersID: '#m-folders_more',
            unseenClass: '.m-folder__unseen'
        },
        actionID: '#actionID',
        btn: {
            name: '.btn',
            groupName: '.btn-group',
            tbarName: '.btn-toolbar',
            validNames: ['danger', 'default', 'primary']
        },
        cache: {},
        composeWin: '',
        dialog: {
            idPref: 'mail-dialog_',
            conf: {
                create: function () {
                    var widget = $(this).dialog('widget');
                    $('.ui-dialog-content', widget).removeClass('hidden');
                },
                height: 'auto',
                dialogClass: 'ii-dialog',
                minWidth: 400,
                modal: true,
                position: {
                    my: 'bottom',
                    at: 'center',
                    of: window
                },
                resizable: false
            }
        },
        ddMenu: {
            panes: '.eml-headers',
            tmpl1: {},
            tmpl2: {}
        },
        flags: [],
        folders: {
            blockClass: '.m-folders',
            itemClass: '.m-folder'
        },
        i18n: {},
        isMobile: (inx.params.isMobile || inx.params.isTablet) ? true : false,
        mail: {
            formID: '#messagesForm',
            rowClass: '.eml'
        },
        pageCName: 'wrap-page',
        printWin: '',
        spinner: {
            color: '#bbb'
        },
        systemDivID: '#system',
        tbMenus: {
            itemsCName: '.ddown_t3',
            subMenus: {}
        },
        // XXX: Convert to function url.get()?
        url: {
            compose: '/compose',
            contacts: '/contact',
            contactsImport: '/contact/import',
            contactsBuilder: '/contact/builder',
            message: '/message'
        }
    };

    /**
    * Helper functions
    */
    // Check for outside click
    var clickOutside = function (e) {
            var el = $(e.target)[0],
                me = this,
                btnGroup = me.btn.parent()[0];

            if (me.btn.parent().hasClass('ddown_open')) {
                if (me.ofElm !== null) {
                    btnGroup = me.ofElm[0];
                }
                while (el) {
                    if (el === btnGroup) {
                        // Must have for regular links
                        return true;
                    }
                    else if (el === document) {
                        me.close();
                        return false;
                    }
                    else {
                        el = el.parentNode;
                    }
                }
            }
        },

        // Currently used only for addresses
        getTemplate = function (selector) {
            this.templates = this.templates || {};
            var tpl = this.templates[selector];
            if (!this.templates[selector]) {
                tpl = $(selector).html();
                this.templates[selector] = tpl;
            }
            return $(tpl);
        },

        // Is button of "type"
        btnTypeIs = function (type) {
            var btnNames = conf.btn.validNames,
                rex = new RegExp('([-_]{1})(' + btnNames.join('|') + ')');
            rex.test($(this).attr('class'));
            return RegExp.$2 === type;
        },

        setParam = function (params, scope) {
            // XXX: Most probably this function might be improved
            // Argument 'params' may be any type, also scope needs to be implemented correctly
            if (scope !== undefined && typeof (scope) === 'string') {
                conf[scope] = conf[scope] || {};
            }
            for (var key in params) {
                if (Object.hasOwnProperty.call(params, key)) {
                    switch (key) {
                    case 'menus':
                        $.extend(conf.tbMenus.subMenus, params.menus);
                        break;
                    default:
                        if (conf[scope] !== undefined) {
                            conf[scope][key] = params[key];
                        }
                        else if (Object.hasOwnProperty.call(conf, key) && (typeof (params[key]) === 'object')) {
                            $.extend(true, conf[key], params[key]);
                        }
                        // jQuery doesn't extend undefined properties
                        else {
                            conf[key] = params[key];
                        }
                    }
                }
            }
        },

        getParam = function (param) {
            return (Object.hasOwnProperty.call(conf, param)) ? conf[param] : false;
        };

    /**
    * Drop-down menu actions for addresses & attachments
    * TODO: Consider merging with the other drop-down handling function
    */
    //
    var ddown = {
        createDDMenu: function () {
            // Do not create drop-down twice
            if (this.btn.parent().find('.ddown').length > 0) {
                return;
            }
            var cddm = new getTemplate('#tmpl-ddm1');
            this.ddm.each(function () {
                var thisData = $(this).data();
                // console.log(this);
                if (thisData.action === 'address') {
                    $('input', cddm).val($(this).text());
                }
                else {
                    $('.ddown__action[data-action="' + thisData.action + '"]', cddm).each(function () {
                        var me = $(this);
                        me.prepend('<i class="ifi-' + me.data('useicon') + '"/>');
                        me.attr('href', thisData.href).css('display', 'block');
                    });
                }
            });
            this.ddm = cddm;
            // address
            if (this.type === 1) {
                this.btn.parent().append(cddm);
            }
            // Attach
            else {
                this.btn.append(cddm);
            }
        },

        close: function () {
            var siblings = null;
            if (arguments.length > 0) {
                siblings = $('.eml-addr, .attach', conf.ddMenu.panes).not(this.btn.parent());
            }
            else {
                siblings = $('.eml-addr, .attach', conf.ddMenu.panes);
            }
            siblings = siblings.filter('.ddown_open').removeClass('ddown_open');
            // Remove dropdown in case of address
            if (this.type === 1) {
                $('.ddown', siblings).remove();
            }

            $(document).unbind('click.ddown');
        },

        open: function () {
            var me = this, ddPos;
            // Drop-down positioning
            switch (me.type) {
            // Attachments
            case 2:
                ddPos = {
                    of: me.ofElm,
                    my: 'right+1 top-1',
                    at: 'right bottom'
                };
                break;
            // Addresses
            default:
                me.createDDMenu();
                ddPos = {
                    of: me.btn,
                    my: 'left top-2',
                    at: 'left bottom'
                };
            }
            me.close('notMe');
            // address
            if (me.type === 1) {
                me.btn.parent().addClass('ddown_open');
            }
            // attach
            else {
                me.btn.addClass('ddown_open');
            }
            me.ddm.position(ddPos);

            // Bind "click outside" event
            $(document).on('click.ddown', function (e) {
                clickOutside.call(me, e);
            });
        },

        /**
        * Toggle drop-down menu
        */
        toggle: function (o) {
            var isOpen;
            o.ofElm = o.ofElm || null;
            // 1- address, 2 - attach
            o.type = o.ofElm ? 2 : 1;
            $.extend(this, o);
            // Address
            if (o.type === 1) {
                isOpen = this.btn.parent().hasClass('ddown_open');
            }
            else {
                isOpen = this.btn.hasClass('ddown_open');
            }

            if (isOpen) {
                this.close();
            }
            else {
                this.open();
            }
        }
    };

    /**
    * Buttons toolbar drop-down toggling
    */
    var ddownT3 = {
        close: function () {
            this.btn.parent().removeClass('ddown_open');
            $(document).unbind('click.ddown');
        },
        open: function () {
            var me = this,
                ddOriginal = conf.tbMenus.subMenus[me.btn.data('action')],
                ddMenu = conf.tbMenus.itemsCName,
                myBtnParent = me.btn.parent(),
                minWidth;

            $(conf.btn.name).parent().not(myBtnParent).removeClass('ddown_open');
            myBtnParent.addClass('ddown_open');

            if ($(ddMenu, myBtnParent).length < 1) {
                me.btn.after(ddOriginal);
                minWidth = me.btn.outerWidth();
                // Ddown menu width has to be >= it's parent width
                if (me.btn.data('action') === 'move') {
                    // NOTE: "Move" drop-down must be wider in case when there is vertical scrollbar
                    var folderBlock = $(conf.folders.blockClass, me.btn.parent())[0],
                        hasScroll = folderBlock.scrollHeight > folderBlock.clientHeight;
                    minWidth += hasScroll ? 49 : 0;
                }
                $(ddMenu, myBtnParent).css('min-width', minWidth);
            }
            // Special positioning for the "master" selector of the mail list
            let positionOpts = {
                of: me.btn,
                my: 'left top-2',
                at: 'left bottom'
            };
            if (myBtnParent.find('.ci-cbox').length > 0) {
                positionOpts = {
                    of: myBtnParent.parent(),
                    my: 'left top',
                    at: 'left+4 bottom+4'
                };
            }

            $(ddMenu, myBtnParent).position(positionOpts);
            // Bind "click outside" event
            $(document).on('click.ddown', function (e) {
                clickOutside.call(me, e);
            });
        },
        toggle: function (o) {
            o.ofElm = o.ofElm || null;
            $.extend(this, o);
            if (this.btn.parent().hasClass('ddown_open')) {
                this.close();
            }
            else {
                this.open();
            }
        }
    };

    /**
    * Click handlers for the toolBars
    */
    let doIt = {};

    // Options: email forwards
    doIt = Object.assign(doIt, {
        'options-forwards': {
            'delete-all': function () {
                doIt['dialog-show']('forwards', 'delete', function () {
                    $('#delall').submit();
                });
            }
        }
    });

    // Modal dialog dispatcher
    doIt = Object.assign(doIt, {
        'dialog-show': function (action, name, callback) {
            var dlgConf = conf.dialog.conf,
                dialogID = '#' + conf.dialog.idPref + action + '-' + name;

            switch (action) {
            case 'identity':
                // Add a new identity name
                if (name === 'add') {
                    $.extend(dlgConf, {
                        open: function () {
                            var me = $(this),
                                widget = me.dialog('widget'),
                                newName = $('#new-identity-name', widget);
                            $('.ui-dialog-buttonpane', widget).on('click', 'button', function () {
                                if (btnTypeIs.call(this, 'primary')) {
                                    callback(newName.val());
                                }
                                newName.val('');
                                me.dialog('close');
                            });
                        }
                    });
                }
                break;
            // Delete email and forward confirmation
            case 'delete':
            case 'forwards':
                $.extend(dlgConf, {
                    open: function () {
                        var me = $(this),
                            widget = me.dialog('widget');
                        $('.ui-dialog-buttonpane', widget).on('click', 'button', function () {
                            if (btnTypeIs.call(this, 'danger')) {
                                callback();
                            }
                            me.dialog('close');
                        });
                    }
                });
                break;
            // Contacts builder: importing contacts
            case 'contacts':
                dialogID = '#contacts-dialog_' + name;
                $.extend(dlgConf, {
                    open: function () {
                        var me = $(this),
                            widget = me.dialog('widget'),
                            importedContactsCount;

                        // Importing contacts - how spinner
                        if (name === 'importing') {
                            var spinOpts = { color: conf.spinner.color, left: '10px', lines: 11, length: 4, radius: 4, shadow: false, width: 2 },
                                spinner = new Spinner(spinOpts).spin();
                            $('.spinner', widget).prepend(spinner.el);
                            $('.ui-dialog-buttonpane', widget).on('click', 'button', function () {
                                // TODO: If button clicked, cancel importing
                                me.dialog('close');
                            });
                        }

                        // Contacts imported
                        if (name === 'imported') {
                            importedContactsCount = (typeof callback === 'number') ? callback : 0;
                            $('#imported-contacts-count', widget).text(importedContactsCount);
                            $('.ui-dialog-buttonpane', widget).on('click', 'button', function () {
                                if (btnTypeIs.call(this, 'primary')) {
                                    location.href = conf.url.contacts;
                                }
                                else {
                                    location.href = conf.url.contactsImport;
                                }
                            });
                        }

                        // Contacts built
                        if (name === 'built') {
                            importedContactsCount = (typeof callback === 'number') ? callback : 0;
                            $('#built-contacts-count', widget).text(importedContactsCount);
                            $('.ui-dialog-buttonpane', widget).on('click', 'button', function () {
                                if (btnTypeIs.call(this, 'primary')) {
                                    location.href = conf.url.contacts;
                                }
                                else {
                                    location.href = conf.url.contactsBuilder;
                                }
                            });
                        }
                    },
                    close: function () {
                        if (name === 'imported') {
                            location.href = conf.url.contacts;
                        }
                    }
                });
                break;
            }
            $(dialogID).dialog(dlgConf);
        }
    });

    // DOM ready functions
    domContentLoaded(function () {
        // Special treating for mobile devices
        $('body').toggleClass('is-mobile', conf.isMobile);

        /**
        * Events handler for messages
        * NOTE: Click handler used for both messages list & mail read
        */
        $(conf.mail.rowClass, conf.mail.formID).on('click', function (e) {
            var emlRow = $(this),
                tg = $(e.target),
                atag = $('a', emlRow),
                isBtnGroup = tg.parents(conf.btn.groupName).length ? true : false;

            /*
                TODO: DRY!!! We already have btn-group handler!
                Don't handle clicks from buttons
            */
            if (isBtnGroup) {
                var btn = tg.closest(conf.btn.name), action, scope;
                e.stopPropagation();
                e.preventDefault();
                if (btn.data()) {
                    scope = btn.data('scope');
                    action = btn.data('action');
                    doIt[scope][action](emlRow);
                }
                return;
            }

            // Click from the subject
            if (tg.closest('a').length > 0) {
                var ahref = tg.closest('a').attr('href');
                // Check if draft message should be opened in new window
                if (ahref.indexOf('actionID=draft') > -1 && ahref.indexOf('popup=1') > -1) {
                    inx.mail.fn.openComposeWin(ahref, '/draft');
                    return false;
                }
                else {
                    return true;
                }
            }
            // Clicked somewhere in the mail row
            // If <tr> has <a> tag
            else if (atag.length > 0) {
                var linkHref = atag.attr('href');
                if (linkHref.indexOf('actionID=draft') > -1 && linkHref.indexOf('popup=1') > -1) {
                    inx.mail.fn.openComposeWin(linkHref, '/draft');
                    return false;
                }
                else if (linkHref.indexOf('popup=1') > -1) {
                    inx.mail.fn.openComposeWin(linkHref);
                    return false;
                }
                else {
                    if (e.which === 2 || e.ctrlKey) {
                        atag.attr('target', '_blank');
                    }
                    atag[0].click();
                }
            }
        });

        /**
        * Click handler for buttons
        */
        $(conf.btn.groupName).on('click', function (e) {
            var tg = $(e.target),
                btn = tg.closest(conf.btn.name),
                fromDDown = tg.parents('.ddown'),
                groupText = tg.closest('.btn-group__text'),
                action, scope;

            if (btn.is('.disabled, :disabled')) {
                return;
            }
            if (btn.data('toggle') === 'ddown') {
                ddownT3.toggle({ btn: btn });
            }
            if (fromDDown.length > 0) {
                // Have to use this, because of split buttons
                btn = tg.parents('.btn-group').find('.btn').filter(function () {
                    return $(this).data('toggle') === 'ddown';
                });
            }

            // Exception for "btn-group__text"
            // Used for attach info
            if (groupText.length > 0) {
                btn = groupText;
                action = groupText.data('action');
                scope = groupText.data('scope');
            }
            else {
                action = btn.data('action');
                scope = btn.data('scope');
            }

            if (!Object.hasOwnProperty.call(doIt, scope)) {
                return true;
            }

            switch (scope) {
            // Options: edit profiles, email forwarding
            case 'options-profiles':
            // fall through
            case 'options-forwards':
                doIt[scope][action]();
                break;
            }
        });

        let contactsClient = null;
        let existingEmails = null;

        try { // NOTE: contactsClient available only on mail read page
            const { apiHost } = inx.mail.params.message;
            contactsClient = new INBOX.classes.ContactsRemoteClient(apiHost.contacts);
        } catch (e) {
            contactsClient = null;
        }

        const asyncGetExistingEmails = (success) => {
            if (existingEmails) return success(existingEmails);
            if (!contactsClient) return success([]);

            var emails = [];
            $('.eml-addr__data li[data-action="address"]').each(function () {
                emails.push($(this).text());
            });

            contactsClient.getExistingContacts(emails, function (d) {
                existingEmails = d;
                success(d);
            });
        };

        // Addresses click handler
        $(conf.ddMenu.panes).on('click', function (e) {
            var tg = $(e.target),
                item = tg.closest('.eml-addr__header'),
                itemParent = item.parent(),
                itemDDown = $('.eml-addr__data', itemParent).children(),
                address = $('[data-action="address"]', itemParent).text(),
                name = item.text();

            // Do not handle the event when target is drop-down menu title
            if (tg.is('.ddown__title')) {
                if (conf.isMobile) {
                    // XXX: Seems it doesn't work on iPad :(
                    tg[0].selectionStart = 0;
                    tg[0].selectionEnd = 999;
                    tg[0].select();
                    tg[0].focus();
                    return false;
                }
                else {
                    tg.select().focus();
                    return false;
                }
            }

            // Email address click handler
            if (item.is('.eml-addr__header')) {
                ddown.toggle({
                    ddm: itemDDown,
                    btn: item
                });
                var addressAddBtn = $('#eml-addr_ddown_a_add');

                asyncGetExistingEmails(function (emails) {
                    console.log(emails);
                    // addressAddBtn.parent().removeClass('loading');

                    if (!emails[address]) {
                        addressAddBtn.click(function () {
                            if (contactsClient) {
                                emails[address] = true;
                                addressAddBtn.parent().addClass('exists');
                                contactsClient.createContact(
                                    (name !== address ? name : ''), [address], 'webmail',
                                    function () {
                                        // FIXME this fīle is used, but conf.ddMenu.panes click event could be not existing
                                        // because class "eml-header" is used here and in SASS files, no usage in html
                                        // only last place where is used old - inx.v6.showFlashMessage
                                        var msg = conf.message.translations.newContactSuccess.replace('%s', escape(name.trim()));
                                        inx.v6.showFlashMessage('success', msg, false, '#flash-messages');
                                    },
                                    function () {
                                        inx.v6.showFlashMessage('danger', conf.message.translations.newContactFail, false, '#flash-messages');
                                    });

                                ddown.toggle({});
                            }
                        });

                    } else {
                        addressAddBtn.parent().addClass('exists');
                    }
                });

                return true;
            }
        });

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

    });

    // Public methods
    return {
        compose: {},
        contacts: {},
        filters: {},
        foldersManager: {},
        identities: {},
        message: {},
        search: {},
        setParam,
        getParam,

        openComposeWin: function (args, path) {
            if (typeof (conf.composeWin) != 'undefined' && conf.composeWin && !conf.composeWin.closed) {
                conf.composeWin.focus();
                return;
            }
            var now = new Date(),
                name = 'compose_windows_' + now.getTime(),
                param, url;

            if (path === void 0) {
                path = conf.url.compose;
            }

            if (args !== '') {
                url = path + '?' + args + '&popup=1&uniq=' + now.getTime();
            }
            else {
                url = path + '?' + 'popup=1&uniq=' + now.getTime();
            }
            param = 'toolbar=no,location=no,status=yes,scrollbars=yes,resizable=yes,width=965,height=650,left=0,top=0';
            conf.composeWin = window.open(url, name, param);
            conf.composeWin.opener = self;
            conf.composeWin.focus();
        },

        openPrintWin: function (args) {
            if (typeof (conf.printWin) != 'undefined' && conf.printWin && !conf.printWin.closed) {
                conf.printWin.close();
            }
            var now = new Date(),
                name = 'print_windows_' + now.getTime(),
                url = conf.url.message + '/print?' + args + '&amp;uniq = ' + now.getTime(),
                param = 'toolbar=yes,location=no,status=yes,scrollbars=yes,resizable=yes,width=630,height=650,left=0,top=0';
            conf.printWin = window.open(url, name, param);
            conf.printWin.opener = self;
        },

        showModalWin: function (action, name, callback) {
            doIt['dialog-show'](action, name, callback);
        },

        /**
        * Toggle CC & BCC visibility
        * NOTE: for Select recipients popup window
        */
        toggleCCandBCC: function () {
            doIt['mail-compose']['toggle-fields'].apply(this, arguments);
        },

        fixsize: function () {
            var bodyRoot = document.getElementById('bodyRoot');
            if (bodyRoot !== null) {
                window.resizeTo(bodyRoot.offsetWidth + 80, bodyRoot.offsetHeight + 120);
                window.focus();
            }
        },

        // Compose autosave
        autosaveKeyForUser: function (user) {
            return 'autosave_for_' + user;
        },

        newContactFromAddressBookObject: function (contact) {

            var newContact = { displayName: contact.object_name, phoneNumbers: [], addresses: [], emails: [] };

            if (contact.object_company || contact.object_title) {
                newContact.job = { company: contact.object_company, title: contact.object_title };
            }

            if (contact.object_homePhone) {
                newContact.phoneNumbers.push({
                    number: contact.object_homePhone,
                    phoneNumberType: 1
                });
            }

            if (contact.object_cellPhone) {
                newContact.phoneNumbers.push({
                    number: contact.object_cellPhone,
                    phoneNumberType: 2
                });
            }

            if (contact.object_workPhone) {
                newContact.phoneNumbers.push({
                    number: contact.object_workPhone,
                    phoneNumberType: 3
                });
            }

            if (contact.object_notes) {
                newContact.note = contact.object_notes;
            }

            if (contact.object_homeAddress) {
                newContact.addresses.push({
                    addressType: 1,
                    formattedAddress: contact.object_homeAddress
                });
            }

            if (contact.object_homeAddress) {
                newContact.addresses.push({
                    addressType: 2,
                    formattedAddress: contact.object_workAddress
                });
            }

            if (contact.object_email) {
                newContact.emails.push({
                    typeCode: 1,
                    address: contact.object_email
                });
            }
            if (contact.object_birthDay) {
                newContact.birthDay = {
                    eventType: 3,
                    date: contact.object_birthDay
                };
            }
            return newContact;
        }
    };
})();

export default { inx, INBOX, mainJs };
